import type {BookmarkXAxisOptions, BookmarkYAxisOptions, ShowClause} from 'common/report/insights/util/types';
import type {InsightsBookmarkParams} from 'common/types/reports/bookmark';

export enum ChartCustomizationUpdateType {
  PrimaryYAxis = `primary axis`,
  SecondaryYAxis = `secondary axis`,
  MetricAxisAssignment = `axis assignment`,
  XAxis = `x axis`,
  Theme = `theme`,
}

export type ChartCustomizationUpdate = {
  primaryYAxis: BookmarkYAxisOptions;
  secondaryYAxis: BookmarkYAxisOptions;
  xAxis?: BookmarkXAxisOptions;
  newShowClauses?: ShowClause[];
};

export type ChartCustomizationAxisProps = {
  bookmarkParams: InsightsBookmarkParams;
  onUpdate: (
    updateType: ChartCustomizationUpdateType,
    update: ChartCustomizationUpdate,
    diff?: Partial<BookmarkYAxisOptions>,
    old?: BookmarkYAxisOptions,
  ) => void;
};
